import { render, staticRenderFns } from "./AsyncImg.vue?vue&type=template&id=23d6d1c2&"
import script from "./AsyncImg.vue?vue&type=script&lang=js&"
export * from "./AsyncImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports